export default "__VITE_ASSET__fccd4b23__"